// Localization data for Ukrainian and Russian

export const translations = {
    uk: {
        // Header
        header: {
            title: "Оренда інструментів",
            rental: "Оренда",
            tools: "Інструменти",
            howItWorks: "Як це працює",
            about: "Про нас",
            business: "Для бізнесу",
            terms: "Договір оренди",
            safety: "Правила безпеки",
            privacy: "Конфіденційність",
        },
        // Main page
        main: {
            availableTools: "Доступні інструменти",
            step1: "Оберіть інструмент",
            step2: "Оберіть термін",
            step3: "Оплатіть",
            step4: "Заберіть",
            notFound: "Вендинговий автомат не знайдено",
        },
        // Tool card
        tool: {
            perHours: "/4год",
            perDay: "/день",
            unavailable: "Недоступний",
            maintenance: "На обслуговуванні",
        },
        // Tool page
        toolPage: {
            title: "Оренда",
            rentalType: "Тип оренди",
            fourHours: "4 години",
            oneDay: "1 день",
            oneWeek: "1 тиждень",
            nightRental: "Ніч",
            nightTime: "20:00 - 09:00",
            nightAvailable: "Повернути до 09:00. Доступно з 20:00 до 04:00",
            returnToNine: "Необхідно повернути до 09:00.",
            duration: "Тривалість",
            hours: "годин",
            aLotOfHours: "години",
            days: "днів",
            day: "день",
            daysTwo: "дні",
            daysFive: "днів",
            toPay: "Вартість",
            rentButton: "Орендувати за",
            addToCart: "Додати до обраного",
            updateInCart: "Оновити в кошику",
            addedToCart: "Додано до кошика",
            cartFull: "Кошик повний (макс. 3)",
            goToCart: "Перейти до кошика",
            unavailable: "Недоступний",
            unavailableNow: "Зараз недоступний",
            maintenance: "На обслуговуванні",
            returnTool: "Повернути",
            loading: "Завантаження...",
            notFound: "Інструмент не знайдено",
            back: "Повернутися",
            error: "Помилка",
            recommendedTools: "Щоб робота йшла швидше, візьміть також...",
        },
        // Cart
        cart: {
            title: "Обрані інструменти",
            empty: "Кошик порожній",
            total: "Разом",
            checkout: "Оформити",
            payButton: "Оплатити",
            confirm: "Підтвердити",
            remove: "Видалити",
            addMore: "Додати ще інструмент",
            item: "інструмент",
            itemsFew: "інструменти",
            items: "інструментів",
            continueShopping: "Продовжити вибір",
            quickAdd: "Швидко додати",
            paymentError: "Не вдалося створити платіж",
            connectionError: "Помилка з'єднання. Спробуйте ще раз.",
            continueOnMachine: "Продовжити на автоматі",
            continueOnPhone: "Продовжити на телефоні",
            phoneQrTitle: "Відскануйте QR-код",
            phoneQrSubtitle: "Наведіть камеру телефону на код для оформлення замовлення",
            phoneQrWaiting: "Очікуємо підтвердження на телефоні...",
            phoneQrConfirmed: "Підтверджено! Переходимо...",
            phoneQrExpired: "QR-код застарів",
            phoneQrExpiredDesc: "Натисніть, щоб згенерувати новий",
            phoneQrError: "Помилка. Спробуйте ще раз.",
            phoneQrRefresh: "Оновити",
            toolRemovedNotice: "Інструмент «{name}» вже недоступний і був видалений з кошика",
            toolBecameUnavailable: "Один або кілька інструментів стали недоступними. Будь ласка, поверніться до каталогу.",
        },
        // Mobile checkout page (phone side of QR flow)
        mobileCheckout: {
            title: "Підтвердьте замовлення",
            subtitle: "Перевірте список інструментів перед оформленням",
            confirmButton: "Так, це моє замовлення",
            loading: "Завантаження...",
            error: "Помилка завантаження",
            errorDesc: "Спробуйте відсканувати QR-код ще раз",
            expired: "Посилання застаріло",
            expiredDesc: "Поверніться до кіоску та спробуйте ще раз",
            total: "Разом",
            confirmed: "Замовлення підтверджено!",
            confirmedDesc: "Продовжте верифікацію та оплату",
        },
        // How it works page
        howItWorksPage: {
            title: "Як орендувати інструмент",
            subtitle: "Простий процес оренди за 4 кроки",
            step1Title: "1. Оберіть інструмент",
            step1Desc:
                "Перегляньте каталог доступних інструментів DeWalt. Кожен інструмент має детальний опис, фото та ціну оренди.",
            step2Title: "2. Виберіть термін оренди",
            step2Desc:
                "Мінімальний термін оренди - 4 години. Ви також можете орендувати на день або декілька днів.",
            step3Title: "3. Оплатіть онлайн",
            step3Desc:
                "Безпечна оплата через Monobank. Ви отримаєте код для отримання інструменту після успішної оплати.",
            step4Title: "4. Заберіть з автомату",
            step4Desc:
                "Підійдіть до вендингового автомату, введіть код на екрані та заберіть ваш інструмент. Поверніть його в той самий автомат після використання.",
            importantTitle: "Важлива інформація",
            important1: "Мінімальний термін оренди: 4 години",
            important2: "Інструмент потрібно повернути в чистому стані",
            important3: "При пошкодженні стягується вартість ремонту",
            important4: "Підтримка: +380937787780",
            metaTitle: "Як орендувати інструмент у Харкові | SmarTOOL",
            metaDescription: "Оренда інструменту в Харкові за 4 прості кроки: обираєте з каталогу, оплачуєте онлайн, забираєте з автомату SmarTOOL або замовляєте доставку. Без застави.",
        },
        // About page
        aboutPage: {
            title: "Про нас",
            subtitle: "SmartTool - оренда професійного інструменту DeWalt",
            description:
                "Ми - перший сервіс автоматизованої оренди електроінструментів у Харкові. Наші вендингові автомати дозволяють швидко та зручно орендувати професійний інструмент DeWalt без черг та паперової тяганини.",
            whyUsTitle: "Чому обирають нас",
            why1Title: "Доступність 24/7",
            why1Desc: "Орендуйте інструмент у будь-який час доби",
            why2Title: "Професійний інструмент",
            why2Desc: "Тільки оригінальний DeWalt у відмінному стані",
            why3Title: "Швидко та зручно",
            why3Desc: "Весь процес займає менше 5 хвилин",
            why4Title: "Прозорі ціни",
            why4Desc: "Ніяких прихованих платежів",
            contactTitle: "Контакти",
            address: "Харків, Україна",
            email: "info@smarttool.ua",
            phone: "+380937787780",
            metaTitle: "Про SmarTOOL — Оренда інструменту у Харкові",
            metaDescription: "SmarTOOL — перший сервіс автоматизованої оренди електроінструменту у Харкові. Профінструмент DeWalt, Bosch, Makita без застави. Автомати 24/7 і доставка.",
        },
        // Business page
        businessPage: {
            metaTitle: "Оренда інструменту для бізнесу в Харкові — SmarTOOL",
            metaDescription: "Оренда інструменту для будівельних компаній, бригад та підрядників у Харкові. Оптові знижки, доставка на об'єкт, без застави. DeWalt, Bosch, Makita.",
            metaKeywords: "оренда інструменту для бізнесу, оренда інструменту для бізнесу харків, оренда інструменту для компаній харків, оренда інструменту для будівельних компаній, оптова оренда інструменту харків, оренда інструменту для підрядників, оренда інструменту для бригад, аренда инструмента для бизнеса харьков, аренда инструмента для компаний, аренда инструмента для строительных компаний харьков, оптовая аренда инструмента, аренда инструмента для подрядчиков, аренда инструмента для бригад",
            title: "Оренда інструменту для бізнесу",
            subtitle: "Вигідні умови для будівельних компаній, бригад та підрядників",
            intro: "SmarTOOL співпрацює з будівельними компаніями, ремонтними бригадами та приватними підрядниками у Харкові. Пропонуємо професійний інструмент DeWalt, Bosch, Makita в оренду на вигідних умовах — без застави, з доставкою на об'єкт та знижками при оренді кількох одиниць.",
            benefit1Title: "Оптом дешевше",
            benefit1Desc: "Знижка при одночасній оренді кількох інструментів для бригади",
            benefit2Title: "Доставка на об'єкт",
            benefit2Desc: "Привеземо інструмент на будмайданчик у Харкові та заберемо після завершення робіт",
            benefit3Title: "Без застави",
            benefit3Desc: "Ідентифікація через застосунок Дія — без грошової застави та паперової тяганини",
            benefit4Title: "Гнучкі терміни",
            benefit4Desc: "Оренда на день, тиждень чи довгостроково — під ваш проєкт",
            ctaTitle: "Підберемо інструмент для вашого проєкту",
            ctaSubtitle: "Зателефонуйте — обговоримо умови співпраці для вашої компанії",
            ctaButton: "Замовити дзвінок",
            backToCatalog: "Переглянути каталог інструменту",
        },
        // Verification page
        verification: {
            title: "Верифікація",
            subtitle: "Підтвердіть вашу особу для оренди",
            switcherDia: "Дія",
            switcherManual: "Вручну",
            diaTitle: "Верифікація через",
            diaDescription:
                "Відскануйте QR-код у застосунку Дія для швидкої верифікації",
            diaDescriptionConfirmed:
                "Верифікація пройшла успішно, дотримуйтесь вказівок на екрані",
            diaQrHint: "Наведіть камеру або натисніть на QR-код",
            diaQrHintKiosk: "Відскануйте QR-код у застосунку Дія на вашому телефоні",
            firstName: "Ім'я",
            lastName: "Прізвище",
            patronymic: "По батькові",
            phone: "Телефон",
            diaPhone: "Телефон (для отримання коду відкриття комірки)",
            otpCode: "Код підтвердження",
            firstNamePlaceholder: "Введіть ваше ім'я",
            lastNamePlaceholder: "Введіть ваше прізвище",
            patronymicPlaceholder: "Необов'язково",
            phonePlaceholder: "+380XXXXXXXXX",
            otpPlaceholder: "1234",
            errorRequired: "Обов'язкове поле",
            errorNameFormat: "Невірний формат імені",
            errorNameMinLength: "Мінімум 3 символи",
            errorPhoneFormat: "Формат: +380XXXXXXXXX",
            errorOtpFormat: "Від 4 до 6 цифр",
            otpModalTitle: "Підтвердіть номер телефону",
            otpModalSentTo: "Код надіслано на номер",
            otpModalConfirm: "Підтвердити",
            otpModalResend: "Надіслати ще раз",
            otpModalResendIn: "Повторно через",
            otpModalError: "Невірний код підтвердження",
            otpSending: "Надсилаємо код...",
            otpSendError: "Не вдалося надіслати SMS. Спробуйте ще раз.",
            warningText:
                "УВАГА: Продовжуючи, ви надаєте згоду на обробку персональних данних, автоматичне підключення рекурентних платежів. Це забезпечує швидке закриття оренди та автоматичне покриття витрат у разі несвоєчасного повернення, пошкодження або втрати інструменту.",
            agreementText: "Я приймаю умови",
            agreementTextRules: "та підтверджую, що ознайомлений з",
            agreementLink: "договору оренди",
            agreementRulesLink:
                "правилами техніки безпеки/використання інструменту",
            errorAgreement: "Необхідно прийняти умови договору",
            continueButton: "Продовжити",
            diaSoon: "Скоро...",
            diaLoading: "Завантаження QR-коду...",
            diaError: "Помилка завантаження",
            diaRetry: "Спробувати знову",
            diaWaiting: "Очікуємо підтвердження у Дії...",
            diaConfirmed: "Особу підтверджено!",
            diaExpired: "QR-код застарів. Натисніть для оновлення.",
            diaRefreshQr: "↺ Оновити QR-код",
            diaAutoRefresh: "Автоматичне оновлення через",
            paymentLoading: "Створення платежу...",
            paymentError: "Не вдалося створити платіж. Спробуйте ще раз.",
            priceChanged: "Ціна змінилася. Перевірте нову суму і натисніть «Продовжити» ще раз.",
            paymentConnectionError: "Помилка з'єднання. Перевірте інтернет та спробуйте ще раз.",
        },
        // Payment result page
        paymentResult: {
            title: "Результат оплати",
            thanks: "Дякуємо!",
            processing: "Ваше замовлення обробляється. Очікуйте підтвердження.",
            orderNumber: "Номер замовлення:",
            whatsNext: "Що далі?",
            step1: "Ви отримаєте SMS з кодом для отримання інструменту",
            step2: "Підійдіть до вендингового автомату",
            step2b: "Натисніть кнопку \"Отримати за кодом\" на головній сторінці",
            step3: "Введіть код на екрані автомату",
            step4: "Заберіть ваш інструмент",
            checkCondition: "Перевірте справність та комплектність інструменту. Якщо є будь-які проблеми — негайно зв'яжіться з нами: +380937787780",
            goHome: "На головну",
            autoRedirect: "Автоматичне перенаправлення через",
            seconds: "сек",
            failed: "Оплата не пройшла",
            failedDesc: "Платіж не було завершено. Спробуйте ще раз.",
            conflictTitle: "Інструмент уже зайнято",
            conflictDesc: "Поки ви оплачували, цей інструмент орендував інший клієнт. Кошти буде повернено — ми зв'яжемося з вами.",
            unconfirmedTitle: "Очікуємо підтвердження оплати",
            unconfirmedDesc: "Банк ще не підтвердив платіж. Якщо кошти списано, замовлення оформиться автоматично і ви отримаєте SMS з кодом. Повторно оплачувати не потрібно.",
        },
        // Payment result page (kiosk mode)
        paymentResultKiosk: {
            title: "Оплату прийнято",
            thanks: "Оплату прийнято",
            processing: "Очікуйте відкриття комірки",
            orderNumber: "Номер замовлення:",
            whatsNext: "Що далі?",
            step1: "Комірка відкриється автоматично",
            step2: "Заберіть ваш інструмент",
            checkCondition: "Перевірте справність та комплектність інструменту. Якщо є будь-які проблеми — негайно зв'яжіться з нами: +380937787780",
            goHome: "Повернутися до каталогу",
            autoRedirect: "Автоматичне перенаправлення через",
            seconds: "сек",
        },
        // Terms page
        terms: {
            title: "Договір оренди",
            back: "Назад",
            safetyButton: "Правила безпеки",
        },
        // Safety page
        safety: {
            title: "Правила безпеки",
        },
        // Privacy page
        privacy: {
            title: "Конфіденційність",
        },
        // Agreement page
        agreement: {
            headerTitle: "Акт прийому-передачі",
            mainTitle: "АКТ ПРИЙОМУ-ПЕРЕДАЧІ ОБЛАДНАННЯ (ДОДАТОК ДО ДОГОВОРУ ОРЕНДИ)",
            s1Title: "ПОРЯДОК ПЕРЕДАЧІ МАЙНА",
            s1p1: "Цей Акт є невід'ємною частиною Публічного договору оренди та підтверджує факт передачі Обладнання від Орендодавця до Орендаря.",
            s1p2: "Сторони погодили, що факт оплати вартості оренди та наступне автоматичне відкриття комірки локера є моментом підписання даного Акту електронним підписом Орендаря (згідно зі ст. 642 ЦК України).",
            s1p3: "В момент відкриття комірки Орендодавець передає, а Орендар приймає Обладнання у робочому стані, без видимих зовнішніх пошкоджень та у повній комплектації (згідно з обраною моделлю інструменту).",
            s2Title: "ОСОБЛИВІ УМОВИ ТА ПЕРЕВІРКА",
            s2p1: "Орендар має 10 (десять) хвилин з моменту відкриття комірки на візуальний огляд та перевірку працездатності інструменту.",
            s2p2: "Якщо протягом вказаного часу Орендар не повідомив службу підтримки про виявлені дефекти, некомплектність або несправність, Обладнання вважається прийнятим Орендарем у належному стані. Претензії щодо стану Обладнання після закінчення 10-хвилинного терміну не приймаються.",
            s3Title: "ПОРЯДОК ПОВЕРНЕННЯ",
            s3p1: "Повернення Обладнання здійснюється шляхом поміщення його у відповідну комірку локера до моменту закінчення терміну оренди.",
            s3p2: "Факт закриття комірки локера та завершення сесії оренди в системі є моментом повернення Обладнання Орендодавцю.",
            s3p3: "Обладнання повинно бути повернуто у чистому та справному стані. У разі повернення інструменту з сильним забрудненням (бетонний пил, бруд тощо), або пошкодженням Орендар погоджується на відшкодування витрат на професійне чищення або ремонт згідно з тарифами Орендодавця.",
            s4Title: "ПІДПИСИ СТОРІН",
            s4p1: "Орендодавець: ФОП Ляшенко Є.С., ІПН 3753403530.",
            s4p2: "Орендар: Фізична особа, що здійснила акцепт умов Договору шляхом оплати та ручного вводу особистих даних або верифікації через систему «Дія».",
        },
        // Navigation
        nav: {
            backToTools: "До інструментів",
        },
        // Return modal (kiosk)
        return: {
            title: "Повернути інструмент",
            choosePrompt: "Як ви орендували інструмент?",
            phoneOption: "За номером телефону",
            phoneOptionDesc: "Якщо вказували номер при оренді",
            nameOption: "Через Дія",
            nameOptionDesc: "Якщо підтверджували особу через застосунок Дія",
            back: "Назад",
            phoneLabel: "Ваш номер телефону",
            phonePlaceholder: "+380XXXXXXXXX",
            nameLabel: "Ваше прізвище",
            namePlaceholder: "Введіть прізвище",
            confirmButton: "Підтвердити повернення",
            checking: "Перевіряємо...",
            errorEmpty: "Будь ласка, заповніть поле",
            errorNotFound: "Активну оренду не знайдено. Перевірте введені дані.",
            errorGeneral: "Помилка. Спробуйте ще раз.",
            successTitle: "Інструмент повернено!",
            successDesc: "Комірка відкриється автоматично",
            slot: "Комірка",
            done: "Готово",
            button: "Повернути інструмент",
        },
        // Get by code
        code: {
            button: "Отримати за кодом",
        },
        // Pickup code modal
        pickup: {
            modalTitle: "Отримання інструменту",
            modalDesc: "Введіть 6-значний код із SMS",
            modalConfirm: "Підтвердити",
            modalLoading: "Перевірка...",
            modalError: "Недійсний або прострочений код",
        },
        // 404 page
        notFound: {
            title: "Сторінку не знайдено",
            subtitle: "Схоже, такої сторінки не існує",
            goHome: "На головну",
        },
        // /rent SEO landing page
        rentPage: {
            metaTitle: "Оренда інструменту Харків — без застави, доставка",
            metaDescription: "Прокат перфоратора, шуруповерта, болгарки у Харкові без застави. DeWalt, Bosch, Makita. Доставка по місту. Передзвонимо за 1 хвилину. Тел: +380937787780",
            metaKeywords: "оренда інструменту харків, оренда перфоратора харків, прокат інструменту харків, оренда без застави харків, оренда з доставкою харків, оренда dewalt харків, оренда bosch харків, оренда makita харків, оренда інструменту для бізнесу харків, оренда інструменту для будівельних компаній, оптова оренда інструменту харків, аренда перфоратора харьков, аренда инструмента харьков без залога, прокат инструмента харьков, аренда болгарки харьков, аренда шуруповерта харьков, аренда дрели харьков, аренда отбойного молотка харьков, аренда инструмента с доставкой харьков, аренда dewalt харьков, аренда bosch харьков, аренда makita харьков, аренда milwaukee харьков, аренда hilti харьков",
            ogTitle: "Оренда інструменту в Харкові — без застави, доставка",
            introTitle: "Прокат електроінструменту у Харкові без застави",
            introText: "SmarTOOL — сервіс оренди електроінструменту у Харкові. Пропонуємо прокат перфораторів DeWalt, шуруповертів, болгарок, дрилів, відбійних молотків та іншого будівельного інструменту. На відміну від традиційних прокатів — ми не вимагаємо грошового залогу та пропонуємо доставку по Харкову. Весь інструмент преміум-класу, перевірений і завжди готовий до роботи.",
            heroTitle: "Оренда інструменту в Харкові",
            heroSubtitle: "Прокат якісного інструменту — без застави, з доставкою",
            callButton: "Зателефонувати",
            callPropose: "Телефонуйте",
            benefit1: "Без застави",
            benefit1Desc: "Берете інструмент без грошового залогу",
            benefit2: "Доставка",
            benefit2Desc: "Привеземо та заберемо по Харкову",
            benefit3: "Преміум інструмент",
            benefit3Desc: "DeWalt, Bosch, Makita — лише якісний профінструмент",
            benefit4: "Разом дешевше",
            benefit4Desc: "Орендуєте 2+ інструменти — платите менше",
            toolsTitle: "Доступні інструменти",
            toolsLoading: "Завантаження...",
            toolsEmpty: "Скоро додамо більше інструментів",
            fromPrice: "від",
            perDay: "грн/доба",
            per4h: "грн/4год",
            perWeek: "грн/тиждень",
            perNight: "грн/ніч",
            sheetClose: "Закрити",
            available: "Доступний",
            unavailable: "Зайнятий",
            faqTitle: "Часті питання",
            faq1q: "Чи потрібен залог?",
            faq1a: "Ні. Ми не беремо грошового залогу. Для оренди достатньо підтвердити особу через застосунок Дія.",
            faq2q: "Чи є доставка по Харкову?",
            faq2a: "Так, доставляємо інструмент по Харкову. Зателефонуйте, щоб уточнити умови та вартість.",
            faq3q: "Які інструменти є в наявності?",
            faq3a: "Перфоратор SDS-Plus, відбійний молоток SDS-Max, штроборіз, мережева та акумуляторна болгарки, шуруповерт, дриль, гайковерт, лобзик, циркулярна пила, мультитул, шліфмашина, технічний фен, будівельний пилосос і детектор проводки. Бренди: DeWalt, Makita, Bosch.",
            faq5q: "Як орендувати перфоратор у Харкові?",
            faq5a: "Зателефонуйте нам або залиште заявку на сайті. Інструмент можна забрати самостійно або замовити доставку.",
            faq6q: "Чи треба документи для оренди?",
            faq6a: "Для ідентифікації використовуємо застосунок Дія — жодних паперових документів не потрібно.",
            ctaTitle: "Зв'яжіться з нами",
            ctaSubtitle: "Зателефонуйте зараз — підберемо інструмент під ваше завдання",
            backToMain: "Замовити онлайн",
            callbackBtn: "Замовити дзвінок",
            callbackBadge: "менеджер передзвонить за ~1 хвилину",
            callbackOr: "або зателефонуйте:",
            callNow: "Подзвонити",
            reviewTitle: "Вже орендували у нас?",
            reviewText: "Залиште відгук у Google — це допомагає іншим знайти надійний прокат",
            reviewBtn: "Залишити відгук у Google",
        },
        // Individual tool SEO landing pages (/rent/:slug)
        toolLandingPage: {
            breadcrumbHome: "Головна",
            specsTitle: "Про оренду цього інструменту",
            faqTitle: "Часті питання",
            priceTitle: "Ціна оренди",
            ctaTitle: "Орендувати цей інструмент",
            ctaSubtitle: "Залиште заявку — менеджер передзвонить протягом хвилини та підбере зручний час доставки",
            relatedTitle: "Часто орендують разом",
            backToHome: "Усі інструменти в оренду",
            availableNow: "Доступний зараз",
            unavailableNow: "Тимчасово недоступний",
            rentButton: "Орендувати",
            termDay: "Доба",
            termNight: "Ніч",
            termWeek: "Тиждень",
            moreToolsTitle: "Інші інструменти в оренду",
            orCall: "або зателефонуйте:",
        },
        callbackModal: {
            title: "Замовити дзвінок",
            termLabel: "Обраний тариф",
            subtitle: "Менеджер передзвонить вам протягом 1 хвилини",
            nameLabel: "Ваше ім'я",
            phoneLabel: "Номер телефону",
            commentLabel: "Коментар (необов'язково)",
            namePlaceholder: "Іван Іванов",
            phonePlaceholder: "+380XXXXXXXXX",
            commentPlaceholder: "Уточніть деталі...",
            submit: "Надіслати",
            success: "Дякуємо! Ми зателефонуємо вам найближчим часом.",
            errorRequired: "Будь ласка, заповніть обов'язкові поля",
            errorPhone: "Введіть коректний номер телефону",
            errorServer: "Сталася помилка. Спробуйте ще раз.",
        },
    },
    ru: {
        // Header
        header: {
            title: "Аренда инструментов",
            rental: "Аренда",
            tools: "Инструменты",
            howItWorks: "Как это работает",
            about: "О нас",
            business: "Для бизнеса",
            terms: "Договор аренды",
            safety: "Правила безопасности",
            privacy: "Конфиденциальность",
        },
        // Main page
        main: {
            availableTools: "Доступные инструменты",
            step1: "Выберите инструмент",
            step2: "Выберите срок",
            step3: "Оплатите",
            step4: "Забрите",
            notFound: "Вендинговый автомат не найден",
        },
        // Tool card
        tool: {
            perHours: "/4ч",
            perDay: "/день",
            unavailable: "Недоступен",
            maintenance: "На обслуживании",
        },
        // Tool page
        toolPage: {
            title: "Аренда",
            rentalType: "Тип аренды",
            fourHours: "4 часа",
            oneDay: "1 день",
            oneWeek: "1 неделя",
            nightRental: "Ночь",
            nightTime: "20:00 - 09:00",
            nightAvailable: "Вернуть до 09:00. Доступно с 20:00 до 04:00",
            returnToNine: "Необходимо вернуть до 09:00.",
            duration: "Продолжительность",
            hours: "часов",
            aLotOfHours: "часа",
            days: "дней",
            day: "день",
            daysTwo: "дня",
            daysFive: "дней",
            toPay: "Стоимость",
            rentButton: "Арендовать за",
            addToCart: "Добавить в избранное",
            updateInCart: "Обновить в корзине",
            addedToCart: "Добавлено в корзину",
            cartFull: "Корзина полная (макс. 3)",
            goToCart: "Перейти в корзину",
            unavailable: "Недоступен",
            unavailableNow: "Сейчас недоступен",
            maintenance: "На обслуживании",
            returnTool: "Вернуть",
            loading: "Загрузка...",
            notFound: "Инструмент не найден",
            back: "Вернуться",
            error: "Ошибка",
            recommendedTools: "Чтобы работа шла быстрее, возьмите также...",
        },
        // Cart
        cart: {
            title: "Корзина",
            empty: "Корзина пуста",
            total: "Итого",
            checkout: "Оформить",
            payButton: "Оплатить",
            confirm: "Подтвердить",
            remove: "Удалить",
            addMore: "Добавить ещё инструмент",
            item: "инструмент",
            itemsFew: "инструмента",
            items: "инструментов",
            continueShopping: "Продолжить выбор",
            quickAdd: "Быстро добавить",
            paymentError: "Не удалось создать платёж",
            connectionError: "Ошибка соединения. Попробуйте ещё раз.",
            continueOnMachine: "Продолжить на автомате",
            continueOnPhone: "Продолжить на телефоне",
            phoneQrTitle: "Отсканируйте QR-код",
            phoneQrSubtitle: "Наведите камеру телефона на код для оформления заказа",
            phoneQrWaiting: "Ожидаем подтверждения на телефоне...",
            phoneQrConfirmed: "Подтверждено! Переходим...",
            phoneQrExpired: "QR-код устарел",
            phoneQrExpiredDesc: "Нажмите, чтобы сгенерировать новый",
            phoneQrError: "Ошибка. Попробуйте ещё раз.",
            phoneQrRefresh: "Обновить",
            toolRemovedNotice: "Инструмент «{name}» уже недоступен и был удалён из корзины",
            toolBecameUnavailable: "Один или несколько инструментов стали недоступны. Пожалуйста, вернитесь в каталог.",
        },
        // Mobile checkout page (phone side of QR flow)
        mobileCheckout: {
            title: "Подтвердите заказ",
            subtitle: "Проверьте список инструментов перед оформлением",
            confirmButton: "Да, это мой заказ",
            loading: "Загрузка...",
            error: "Ошибка загрузки",
            errorDesc: "Попробуйте отсканировать QR-код ещё раз",
            expired: "Ссылка устарела",
            expiredDesc: "Вернитесь к киоску и попробуйте ещё раз",
            total: "Итого",
            confirmed: "Заказ подтверждён!",
            confirmedDesc: "Продолжите верификацию и оплату",
        },
        // How it works page
        howItWorksPage: {
            title: "Как арендовать инструмент",
            subtitle: "Простой процесс аренды за 4 шага",
            step1Title: "1. Выберите инструмент",
            step1Desc:
                "Просмотрите каталог доступных инструментов DeWalt. Каждый инструмент имеет детальное описание, фото и цену аренды.",
            step2Title: "2. Выберите срок аренды",
            step2Desc:
                "Минимальный срок аренды - 4 часа. Вы также можете арендовать на день или несколько дней.",
            step3Title: "3. Оплатите онлайн",
            step3Desc:
                "Безопасная оплата через Monobank. Вы получите код для получения инструмента после успешной оплаты.",
            step4Title: "4. Заберите из автомата",
            step4Desc:
                "Подойдите к вендинговому автомату, введите код на экране и заберите ваш инструмент. Верните его в тот же автомат после использования.",
            importantTitle: "Важная информация",
            important1: "Минимальный срок аренды: 4 часа",
            important2: "Инструмент нужно вернуть в чистом состоянии",
            important3: "При повреждении взимается стоимость ремонта",
            important4: "Поддержка: +380937787780",
            metaTitle: "Как арендовать инструмент в Харькове | SmarTOOL",
            metaDescription: "Аренда инструмента в Харькове за 4 простых шага: выбираете из каталога, оплачиваете онлайн, получаете в автомате SmarTOOL или заказываете доставку. Без залога.",
        },
        // About page
        aboutPage: {
            title: "О нас",
            subtitle: "SmartTool - аренда профессионального инструмента DeWalt",
            description:
                "Мы - первый сервис автоматизированной аренды электроинструментов в Харькове. Наши вендинговые автоматы позволяют быстро и удобно арендовать профессиональный инструмент DeWalt без очередей и бумажной волокиты.",
            whyUsTitle: "Почему выбирают нас",
            why1Title: "Доступность 24/7",
            why1Desc: "Арендуйте инструмент в любое время суток",
            why2Title: "Профессиональный инструмент",
            why2Desc: "Только оригинальный DeWalt в отличном состоянии",
            why3Title: "Быстро и удобно",
            why3Desc: "Весь процесс занимает менее 5 минут",
            why4Title: "Прозрачные цены",
            why4Desc: "Никаких скрытых платежей",
            contactTitle: "Контакты",
            address: "Харьков, Украина",
            email: "info@smarttool.ua",
            phone: "+380937787780",
            metaTitle: "О SmarTOOL — Аренда инструмента в Харькове",
            metaDescription: "SmarTOOL — первый сервис автоматизированной аренды электроинструмента в Харькове. Профинструмент DeWalt, Bosch, Makita без залога. Автоматы 24/7 и доставка.",
        },
        // Business page
        businessPage: {
            metaTitle: "Аренда инструмента для бизнеса в Харькове — SmarTOOL",
            metaDescription: "Аренда инструмента для строительных компаний, бригад и подрядчиков в Харькове. Оптовые скидки, доставка на объект, без залога. DeWalt, Bosch, Makita.",
            metaKeywords: "аренда инструмента для бизнеса, аренда инструмента для бизнеса харьков, аренда инструмента для компаний харьков, аренда инструмента для строительных компаний, оптовая аренда инструмента харьков, аренда инструмента для подрядчиков, аренда инструмента для бригад, оренда інструменту для бізнесу харків, оренда інструменту для компаній, оренда інструменту для будівельних компаній харків, оптова оренда інструменту, оренда інструменту для підрядників",
            title: "Аренда инструмента для бизнеса",
            subtitle: "Выгодные условия для строительных компаний, бригад и подрядчиков",
            intro: "SmarTOOL сотрудничает со строительными компаниями, ремонтными бригадами и частными подрядчиками в Харькове. Предлагаем профессиональный инструмент DeWalt, Bosch, Makita в аренду на выгодных условиях — без залога, с доставкой на объект и скидками при аренде нескольких единиц.",
            benefit1Title: "Оптом дешевле",
            benefit1Desc: "Скидка при одновременной аренде нескольких инструментов для бригады",
            benefit2Title: "Доставка на объект",
            benefit2Desc: "Привезём инструмент на стройплощадку в Харькове и заберём после завершения работ",
            benefit3Title: "Без залога",
            benefit3Desc: "Идентификация через приложение Дія — без денежного залога и бумажной волокиты",
            benefit4Title: "Гибкие сроки",
            benefit4Desc: "Аренда на день, неделю или долгосрочно — под ваш проект",
            ctaTitle: "Подберём инструмент для вашего проекта",
            ctaSubtitle: "Позвоните — обсудим условия сотрудничества для вашей компании",
            ctaButton: "Заказать звонок",
            backToCatalog: "Посмотреть каталог инструмента",
        },
        // Verification page
        verification: {
            title: "Верификация",
            subtitle: "Подтвердите вашу личность для аренды",
            switcherDia: "Дія",
            switcherManual: "Вручную",
            diaTitle: "Верификация через",
            diaDescription:
                "Отсканируйте QR-код в приложении Дія для быстрой верификации",
            diaDescriptionConfirmed:
                "Верификация пройдена успешно, следуйте указаниям на экране",
            diaQrHint: "Наведите камеру или нажмите на QR-код",
            diaQrHintKiosk: "Отсканируйте QR-код в приложении Дія на вашем телефоне",
            firstName: "Имя",
            lastName: "Фамилия",
            patronymic: "Отчество",
            phone: "Телефон",
            diaPhone: "Телефон (для получения кода открытия ячейки)",
            otpCode: "Код подтверждения",
            firstNamePlaceholder: "Введите ваше имя",
            lastNamePlaceholder: "Введите вашу фамилию",
            patronymicPlaceholder: "Необязательно",
            phonePlaceholder: "+380XXXXXXXXX",
            otpPlaceholder: "1234",
            errorRequired: "Обязательное поле",
            errorNameFormat: "Неверный формат имени",
            errorNameMinLength: "Минимум 3 символа",
            errorPhoneFormat: "Формат: +380XXXXXXXXX",
            errorOtpFormat: "От 4 до 6 цифр",
            otpModalTitle: "Подтвердите номер телефона",
            otpModalSentTo: "Код отправлен на номер",
            otpModalConfirm: "Подтвердить",
            otpModalResend: "Отправить ещё раз",
            otpModalResendIn: "Повторно через",
            otpModalError: "Неверный код подтверждения",
            otpSending: "Отправляем код...",
            otpSendError: "Не удалось отправить SMS. Попробуйте ещё раз.",
            warningText:
                "ВНИМАНИЕ: Продолжая, вы даете согласие на обработку персональных данных, автоматическое подключение рекурентных платежей. Это обеспечивает быстрое закрытие аренды и автоматическое покрытие расходов в случае несвоевременного возврата, повреждения или утери инструмента.",
            agreementText: "Я принимаю условия",
            agreementTextRules: "и подтверждаю, что ознакомлен с",
            agreementLink: "договора аренды",
            agreementRulesLink:
                "правилами техники безопасности/использования инструмента",
            errorAgreement:
                "Необходимо принять условия договора",
            continueButton: "Продолжить",
            diaSoon: "Скоро...",
            diaLoading: "Загрузка QR-кода...",
            diaError: "Ошибка загрузки",
            diaRetry: "Попробовать снова",
            diaWaiting: "Ожидаем подтверждение в Дії...",
            diaConfirmed: "Личность подтверждена!",
            diaExpired: "QR-код устарел. Нажмите для обновления.",
            diaRefreshQr: "↺ Обновить QR-код",
            diaAutoRefresh: "Автоматическое обновление через",
            paymentLoading: "Создание платежа...",
            paymentError: "Не удалось создать платёж. Попробуйте ещё раз.",
            priceChanged: "Цена изменилась. Проверьте новую сумму и нажмите «Продолжить» ещё раз.",
            paymentConnectionError: "Ошибка соединения. Проверьте интернет и попробуйте ещё раз.",
        },
        // Payment result page
        paymentResult: {
            title: "Результат оплаты",
            thanks: "Спасибо!",
            processing: "Ваш заказ обрабатывается. Ожидайте подтверждения.",
            orderNumber: "Номер заказа:",
            whatsNext: "Что дальше?",
            step1: "Вы получите SMS с кодом для получения инструмента",
            step2: "Подойдите к вендинговому автомату",
            step2b: "Нажмите кнопку \"Получить по коду\" на главной странице",
            step3: "Введите код на экране автомата",
            step4: "Заберите ваш инструмент",
            checkCondition: "Проверьте исправность и комплектность инструмента. Если есть какие-либо проблемы — немедленно свяжитесь с нами: +380937787780",
            goHome: "На главную",
            autoRedirect: "Автоматическое перенаправление через",
            seconds: "сек",
            failed: "Оплата не прошла",
            failedDesc: "Платёж не был завершён. Попробуйте ещё раз.",
            conflictTitle: "Инструмент уже занят",
            conflictDesc: "Пока вы оплачивали, этот инструмент арендовал другой клиент. Средства будут возвращены — мы свяжемся с вами.",
            unconfirmedTitle: "Ожидаем подтверждение оплаты",
            unconfirmedDesc: "Банк ещё не подтвердил платёж. Если средства списаны, заказ оформится автоматически и вы получите SMS с кодом. Повторно оплачивать не нужно.",
        },
        // Payment result page (kiosk mode)
        paymentResultKiosk: {
            title: "Оплата принята",
            thanks: "Оплата принята",
            processing: "Ожидайте открытия ячейки",
            orderNumber: "Номер заказа:",
            whatsNext: "Что дальше?",
            step1: "Ячейка откроется автоматически",
            step2: "Заберите ваш инструмент",
            checkCondition: "Проверьте исправность и комплектность инструмента. Если есть какие-либо проблемы — немедленно свяжитесь с нами: +380937787780",
            goHome: "Вернуться в каталог",
            autoRedirect: "Автоматическое перенаправление через",
            seconds: "сек",
        },
        // Terms page
        terms: {
            title: "Договор аренды",
            back: "Назад",
            safetyButton: "Правила безопасности",
        },
        // Safety page
        safety: {
            title: "Правила безопасности",
        },
        // Privacy page
        privacy: {
            title: "Конфиденциальность",
        },
        // Agreement page
        agreement: {
            headerTitle: "Акт приёма-передачи",
            mainTitle: "АКТ ПРИЁМА-ПЕРЕДАЧИ ОБОРУДОВАНИЯ (ПРИЛОЖЕНИЕ К ДОГОВОРУ АРЕНДЫ)",
            s1Title: "ПОРЯДОК ПЕРЕДАЧИ ИМУЩЕСТВА",
            s1p1: "Настоящий Акт является неотъемлемой частью Публичного договора аренды и подтверждает факт передачи Оборудования от Арендодателя к Арендатору.",
            s1p2: "Стороны согласились, что факт оплаты стоимости аренды и последующее автоматическое открытие ячейки локера является моментом подписания данного Акта электронной подписью Арендатора (согласно ст. 642 ГК Украины).",
            s1p3: "В момент открытия ячейки Арендодатель передаёт, а Арендатор принимает Оборудование в рабочем состоянии, без видимых внешних повреждений и в полной комплектации (согласно выбранной модели инструмента).",
            s2Title: "ОСОБЫЕ УСЛОВИЯ И ПРОВЕРКА",
            s2p1: "Арендатор имеет 10 (десять) минут с момента открытия ячейки на визуальный осмотр и проверку работоспособности инструмента.",
            s2p2: "Если в течение указанного времени Арендатор не уведомил службу поддержки об обнаруженных дефектах, некомплектности или неисправности, Оборудование считается принятым Арендатором в надлежащем состоянии. Претензии относительно состояния Оборудования по истечении 10-минутного срока не принимаются.",
            s3Title: "ПОРЯДОК ВОЗВРАТА",
            s3p1: "Возврат Оборудования осуществляется путём помещения его в соответствующую ячейку локера до момента истечения срока аренды.",
            s3p2: "Факт закрытия ячейки локера и завершения сессии аренды в системе является моментом возврата Оборудования Арендодателю.",
            s3p3: "Оборудование должно быть возвращено в чистом и исправном состоянии. В случае возврата инструмента с сильным загрязнением (бетонная пыль, грязь и т.п.), или повреждением, Арендатор соглашается на возмещение расходов на профессиональную чистку согласно тарифам Арендодателя.",
            s4Title: "ПОДПИСИ СТОРОН",
            s4p1: "Арендодатель: ФЛП Ляшенко Е.С., ИНН 3753403530.",
            s4p2: "Арендатор: Физическое лицо, осуществившее акцепт условий Договора путём оплаты и ручного ввода личных данных или верификации через систему «Дія».",
        },
        // Navigation
        nav: {
            backToTools: "К инструментам",
        },
        // Return modal (kiosk)
        return: {
            title: "Вернуть инструмент",
            choosePrompt: "Как вы арендовали инструмент?",
            phoneOption: "По номеру телефона",
            phoneOptionDesc: "Если указывали номер при аренде",
            nameOption: "Через Дія",
            nameOptionDesc: "Если подтверждали личность через приложение Дія",
            back: "Назад",
            phoneLabel: "Ваш номер телефона",
            phonePlaceholder: "+380XXXXXXXXX",
            nameLabel: "Ваша фамилия",
            namePlaceholder: "Введите фамилию",
            confirmButton: "Подтвердить возврат",
            checking: "Проверяем...",
            errorEmpty: "Пожалуйста, заполните поле",
            errorNotFound: "Активная аренда не найдена. Проверьте введённые данные.",
            errorGeneral: "Ошибка. Попробуйте ещё раз.",
            successTitle: "Инструмент возвращён!",
            successDesc: "Ячейка откроется автоматически",
            slot: "Ячейка",
            done: "Готово",
            button: "Вернуть инструмент",
        },
        // Get by code
        code: {
            button: "Получить по коду",
        },
        // Pickup code modal
        pickup: {
            modalTitle: "Получение инструмента",
            modalDesc: "Введите 6-значный код из SMS",
            modalConfirm: "Подтвердить",
            modalLoading: "Проверка...",
            modalError: "Недействительный или просроченный код",
        },
        // 404 page
        notFound: {
            title: "Страница не найдена",
            subtitle: "Похоже, такой страницы не существует",
            goHome: "На главную",
        },
        // /rent SEO landing page
        rentPage: {
            metaTitle: "Аренда инструмента в Харькове — без залога, доставка",
            metaDescription: "Аренда перфоратора, шуруповёрта, болгарки, дрели в Харькове. DeWalt, Bosch, Makita. Без залога. Доставка по Харькову. Тел: +380937787780",
            metaKeywords: "аренда перфоратора харьков, аренда инструмента харьков, прокат инструмента харьков, аренда инструмента без залога харьков, аренда с доставкой харьков, аренда dewalt харьков, аренда bosch харьков, аренда makita харьков, аренда milwaukee харьков, аренда hilti харьков, аренда шуруповерта харьков, аренда болгарки харьков, аренда дрели харьков, аренда отбойного молотка харьков, аренда лобзика харьков, прокат электроинструмента харьков, аренда инструмента для бизнеса харьков, аренда инструмента для строительных компаний, оптовая аренда инструмента харьков, оренда інструменту харків, оренда перфоратора харків, прокат інструменту харків без застави",
            ogTitle: "Аренда инструмента в Харькове — без залога, с доставкой",
            heroTitle: "Аренда инструмента в Харькове",
            heroSubtitle: "Прокат качественного инструмента — без залога, с доставкой",
            callButton: "Позвонить",
            callPropose: "Звоните",
            benefit1: "Без залога",
            benefit1Desc: "Берёте инструмент без денежного залога",
            benefit2: "Доставка",
            benefit2Desc: "Привезём и заберём по Харькову",
            benefit3: "Премиум инструмент",
            benefit3Desc: "DeWalt, Bosch, Makita — только качественный профинструмент. Мы бережём ваше здоровье",
            benefit4: "Вместе дешевле",
            benefit4Desc: "Арендуете 2+ инструмента — платите меньше",
            toolsTitle: "Доступные инструменты",
            toolsLoading: "Загрузка...",
            toolsEmpty: "Скоро добавим больше инструментов",
            fromPrice: "от",
            perDay: "грн/сутки",
            per4h: "грн/4ч",
            perWeek: "грн/неделя",
            perNight: "грн/ночь",
            sheetClose: "Закрыть",
            available: "Доступен",
            unavailable: "Занят",
            introTitle: "Прокат электроинструмента в Харькове без залога",
            introText: "SmarTOOL — сервис аренды электроинструмента в Харькове. Предлагаем прокат перфораторов DeWalt, шуруповёртов, болгарок, дрелей, отбойных молотков и другого строительного инструмента. В отличие от традиционных прокатов — мы не требуем денежного залога и предлагаем доставку по Харькову. Весь инструмент премиум-класса, проверен и всегда готов к работе.",
            faqTitle: "Частые вопросы",
            faq1q: "Нужен ли залог?",
            faq1a: "Нет. Мы не берём денежного залога. Для аренды достаточно подтвердить личность через приложение Дія.",
            faq2q: "Есть ли доставка по Харькову?",
            faq2a: "Да, доставляем инструмент по Харькову. Позвоните, чтобы уточнить условия и стоимость.",
            faq3q: "Какие инструменты есть в наличии?",
            faq3a: "Перфоратор SDS-Plus, отбойный молоток SDS-Max, штроборез, сетевая и аккумуляторная болгарки, шуруповёрт, дрель, гайковёрт, лобзик, циркулярная пила, мультитул, шлифмашина, технический фен, строительный пылесос и детектор проводки. Бренды: DeWalt, Makita, Bosch.",
            faq5q: "Как арендовать перфоратор в Харькове?",
            faq5a: "Позвоните нам или оставьте заявку на сайте. Инструмент можно забрать самостоятельно или заказать доставку.",
            faq6q: "Нужны ли документы для аренды?",
            faq6a: "Для идентификации используем приложение Дія — никаких бумажных документов не нужно.",
            ctaTitle: "Свяжитесь с нами",
            ctaSubtitle: "Позвоните сейчас — подберём инструмент под вашу задачу",
            backToMain: "Заказать онлайн",
            callbackBtn: "Заказать звонок",
            callbackBadge: "менеджер перезвонит за ~1 минуту",
            callbackOr: "или позвоните:",
            callNow: "Позвонить",
            reviewTitle: "Уже арендовали у нас?",
            reviewText: "Оставьте отзыв в Google — это помогает другим найти надёжный прокат",
            reviewBtn: "Оставить отзыв в Google",
        },
        // Individual tool SEO landing pages (/rent/:slug)
        toolLandingPage: {
            breadcrumbHome: "Главная",
            specsTitle: "Об аренде этого инструмента",
            faqTitle: "Частые вопросы",
            priceTitle: "Цена аренды",
            ctaTitle: "Арендовать этот инструмент",
            ctaSubtitle: "Оставьте заявку — менеджер перезвонит в течение минуты и подберёт удобное время доставки",
            relatedTitle: "Часто арендуют вместе",
            backToHome: "Все инструменты в аренду",
            availableNow: "Доступен сейчас",
            unavailableNow: "Временно недоступен",
            rentButton: "Арендовать",
            termDay: "Сутки",
            termNight: "Ночь",
            termWeek: "Неделя",
            moreToolsTitle: "Другие инструменты в аренду",
            orCall: "или позвоните:",
        },
        callbackModal: {
            title: "Заказать звонок",
            termLabel: "Выбранный тариф",
            subtitle: "Менеджер перезвонит вам в течение 1 минуты",
            nameLabel: "Ваше имя",
            phoneLabel: "Номер телефона",
            commentLabel: "Комментарий (необязательно)",
            namePlaceholder: "Иван Иванов",
            phonePlaceholder: "+380XXXXXXXXX",
            commentPlaceholder: "Уточните детали...",
            submit: "Отправить",
            success: "Спасибо! Мы перезвоним вам в ближайшее время.",
            errorRequired: "Пожалуйста, заполните обязательные поля",
            errorPhone: "Введите корректный номер телефона",
            errorServer: "Произошла ошибка. Попробуйте ещё раз.",
        },
    },
};

export const defaultLanguage = "uk";

export const getTranslation = (lang, path) => {
    const keys = path.split(".");
    let result = translations[lang] || translations[defaultLanguage];

    for (const key of keys) {
        result = result?.[key];
    }

    return result || path;
};
